import React from 'react'
import './SkillContainer.scss';
import SkillSection from './SkillSection';

const SkillContainer = () => {
    return (
        <div className="skillsContainer">
                <SkillSection skill={'Javascript'} progress={'60%'} width={'60%'} />
                <SkillSection skill={'React Js'} progress={'60%'} width={'60%'} />
                <SkillSection skill={'HTML'} progress={'70%'} width={'70%'} />
                <SkillSection skill={'CSS'} progress={'60%'} width={'60%'} />
                <SkillSection skill={'Bootstrap'} progress={'40%'} width={'40%'} />
                <SkillSection skill={'SQL'} progress={'50%'} width={'50%'} />
                <SkillSection skill={'MySQL'} progress={'55%'} width={'55%'} />
                <SkillSection skill={'SASS'} progress={'50%'} width={'50%'} />
            </div>
    )
}

export default SkillContainer
